import { isValidQuery } from "components/hostedScrapingValidators";
import { SDEContent } from "./sdecontentTypes";

export const ChatGPTContent: SDEContent = {
  projectType: 'async_chatgpt',
  projectCategory: 'chatgpt',
  apiUrlFn: (apiHost: string) => {
    return `${apiHost}/structured/chatgpt/search/v1`;
  },
  docsSection: '',
  docsSectionTitle: '',
  docsSectionAsync: '',
  docsSectionAsyncTitle: '',
  inputKey: 'query',
  inputsKey: 'queries',
  validatorFunction: isValidQuery,
  newProjectEditProject: {
    inputBoxLabels: {
      listLiteralInputTitle: 'Prompts',
      listLiteralInputPlaceholder: 'Enter one prompt per line.',
    },
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: "Enter the prompts you want to send to ChatGPT.",
    },
    projectContent: {
      title: 'ChatGPT',
      description: 'Send prompts to ChatGPT and receive structured answers, optionally with web search sources.',
      icon: 'chatgpt',
      inputTitle: 'Prompt',
    },
  },
  apiPlayground: {
    inputSectionLabels: {
      inputSectionTitle: 'Input prompts',
      inputSectionDescription: 'Enter the prompts you want to send to ChatGPT.',
    },
    projectContent: {
      title: 'ChatGPT',
      description: 'Send prompts to ChatGPT and receive structured answers, optionally with web search sources.',
      icon: 'chatgpt',
    },
    enterInputsPlaceholder: 'Enter a prompt for ChatGPT',
    enterInputsMessage: 'Enter a prompt for ChatGPT',
    codeViewPlaceHolder: 'Please provide a valid prompt',
    dropdownTitle: 'ChatGPT'
  }
};
